/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'

export default {
    SET_TEAMS (state, income) {
        income.data.result.forEach(team => team.internalId = team.is_internal === 1 ? '1' : String(team.id))
        state.teams = income.data.result.map(item => {
            const arr_type = item.types.split('')
            const users = item.users.map(user => user.name)
            const advertiser_teams_integrations = item.advertiser_teams_integrations || []

            if (!item.integrations) item.integrations = []

            item.name = item.name || item.id
            item.advertiser_teams_integrations_length = advertiser_teams_integrations.length
            item.usersList = users
            item.usersLength = users.length
            item.integrationsLength = item.integrations.length

            item.is_hot = ~~arr_type[arr_type.length - 2]
            item.is_hide_autologin = ~~arr_type[arr_type.length - 1]

            return item
        })
    },
    CREATE_TEAM (state, income) {
        const temp = [...state.teams]
        temp.unshift(income.data.result[0])
        Vue.set(state, 'teams', temp)
    },
    EDIT_TEAM (state, {data, income}) {
        for (const index in state.teams) {
            if (state.teams[index].id === income.data.id) {
                Object.assign(state.teams[index], data.result[0])
                confirm
            }
        }
        // const temp = [...state.teams]
        // temp[income.ids.arrId] = data.result[0]
        // Vue.set(state, 'teams', temp)
    },
    CHANGE_TEAM_STATUS (state, {income}) {
        state.teams = state.teams.map((element) => {
            if (element.id === income.data.id) {
                element.is_active = !element.is_active
            }
            return element
        })
    },
    FETCH_TEAM_INTEGRATIONS (state, income) {
        if (state.teams_integrations.length) {
            income.data.result.map(i => {
                const list = state.teams_integrations.some(el => el.id === i.id)
                if (!list) state.teams_integrations.push(i)
            })
        } else {
            state.teams_integrations = income.data.result
        }
    },
    CREATE_TEAM_INTEGRATIONS (state, income) {
        // const temp = [...state.teams_integrations]
        // temp[income.data.item.team_id].push(income.data.result)
        // Vue.set(state, 'teams_integrations', temp)
    },
    EDIT_TEAM_INTEGRATIONS (state, income) {
        // RESULT IS EMPTY NOW
    },
    REMOVE_TEAM_INTEGRATIONS (state, income) {
        // RESULT IS EMPTY NOW
    },
    CLEAR_TEAMS (state) {
        state.teams = [];
        state.teams_integrations = [];
    }
}
